import { Injectable } from '@angular/core';
import { Scontract } from '@cl/shared/models/scontracts/scontract.model';
import { BaseServiceWithFilter } from './base.service';
import { HttpClient } from '@angular/common/http';
import { CommandResult } from '@cl/shared/models';
import { ScontractFilter } from '@cl/shared/models/scontracts/scontract-filter.model';

@Injectable({
    providedIn: 'root',
})
export class ScontractsService extends BaseServiceWithFilter<Scontract, ScontractFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/scontracts/');
    }

    getScontractDetails(id: number): Promise<CommandResult<Scontract>> {
        return this.httpClient.get<CommandResult<Scontract>>(`${this.baseApiUrl}details/${id}`).toPromise();
    }

    toString(object: Scontract): string {
        return `${object.scontractType.name}: ${object.number}`;
    }
}
